import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useCreateWaiverTemplate } from "../../../hooks/waivers/useCreateWaiverTemplate";

const DefaultWaiverTemplatesSeederDialog = ({ open = false, setOpen, successCallback }) => {
  const { t } = useTranslation("common");

  const [defaultWaiverTemplates, setDefaultWaiverTemplates] = useState([
    { name: "General Consent Form", content: "" },
    { name: "Anaesthesia Consent Form", content: "" },
    { name: "Euthanasia Consent Form", content: "" },
    { name: "Boarding and Grooming Waiver", content: "" }
  ]);

  const { create } = useCreateWaiverTemplate(successCallback);

  const handleClose = (event, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      return;
    }
    setOpen(false);
  };

  const onConfirm = async () => {
    await createRecords();
    setOpen(false);
  };

  const createRecords = async () => {
    await create(defaultWaiverTemplates);
  };

  // Load HTML files into template content
  useEffect(() => {
    const fileMap = {
      "General Consent Form": "general-consent.html",
      "Anaesthesia Consent Form": "anaesthesia-consent.html",
      "Euthanasia Consent Form": "euthanasia-consent.html",
      "Boarding and Grooming Waiver": "boarding-grooming-consent.html"
    };

    Promise.all(
      Object.entries(fileMap).map(([name, file]) =>
        fetch(`/${file}`).then(res => res.text())
      )
    ).then(contents => {
      const enrichedTemplates = defaultWaiverTemplates.map((tpl, i) => ({
        ...tpl,
        content: contents[i]
      }));
      setDefaultWaiverTemplates(enrichedTemplates);
    });
  }, []);

  return (
    <Dialog open={open} onClose={handleClose} disableRestoreFocus>
      <DialogTitle>Waiver Templates Initial Setup...</DialogTitle>
      <DialogContent>
        <Typography variant="body1">
          The system has created a default set of Waiver Templates.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onConfirm} color="primary">
          Got it
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DefaultWaiverTemplatesSeederDialog;